import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { LearningCurveData } from '../../../../types/learning';
import styles from './SequenceSkillProgressChart.module.css';

interface SequenceSkillProgressChartProps {
  data: LearningCurveData[];
}

const SequenceSkillProgressChart: React.FC<SequenceSkillProgressChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className={styles.noData}>No progress on sequence infiltration to report, Agent. Awaiting your next move.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'var(--spy-light, #f8f8f8)',
            border: '1px solid var(--spy-dark, #555)',
            color: 'var(--spy-dark, #333)',
            fontFamily: 'var(--font-primary, sans-serif)'
          }}
        />
        <Legend wrapperStyle={{ fontFamily: 'var(--font-primary, sans-serif)' }} />
        <Line type="monotone" dataKey="reviewed" stroke="#1A3A63" activeDot={{ r: 6 }} name="Sequences Engaged" />
        <Line type="monotone" dataKey="mastered" stroke="#4a7c59" activeDot={{ r: 6 }} name="Sequences Decoded" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default React.memo(SequenceSkillProgressChart); 